module.exports = __webpack_public_path__ + "static/img/ddhzyk-img8.a46d183a.jpg";